/**
 * Constructs URLs for various application routes
 */

/**
 * Creates a URL for creating a quote from a template
 */
export function getQuoteFromTemplateUrl(
  templateId: string,
  origin = window.location.origin
): string {
  return `${origin}/quotes/new?quoteTemplateId=${templateId}`
}
